import type { AccordionSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import { hover } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

import type { Position } from '../AccordionElement'
import { transformArrayToString } from './styled'

const right = css`
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;
`

const TitleStyled = styled.button<{
  $isOpen?: boolean
  $styles: ElementStyleCss<AccordionSchemaType>
}>`
  transition: 0.3s;
  cursor: pointer;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  border: none;
  width: 100%;
  ${outline}
  border-top-left-radius: ${({ $styles }) => $styles.border.borderRadius};
  border-top-right-radius: ${({ $styles }) => $styles.border.borderRadius};
  border-bottom-left-radius: ${({ $styles, $isOpen }) => !$isOpen && $styles.border.borderRadius};
  border-bottom-right-radius: ${({ $styles, $isOpen }) => !$isOpen && $styles.border.borderRadius};

  ${({ $styles }) => ($styles.icon?.position as Position) === 'right' && right}

  padding: ${({ $styles }) => transformArrayToString($styles.indents.accordion)};
  background-color: ${({ $styles }) => $styles.collapse.backgroundColor};
  background-color: ${({ $isOpen, $styles }) => $isOpen && $styles.select.backgroundColor};

  ${hover}
`

export default TitleStyled
